import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/icon'
import { Button } from '@/components/ui'
import { AtendimentoDropdownMenu } from '@/features/atendimento/shared/components/atendimento-dropdown'
import { useAtendimento } from '@/hooks/use-atendimento'
import { useLocaleConfig } from '@/hooks/use-locale-config'
import { useCountryNavigate } from '@/hooks/use-localized-navigate'

export const AtendimentoTrigger = () => {
  const { t } = useTranslation('atendimento')
  const navigate = useCountryNavigate()
  const { exibirItens } = useLocaleConfig()
  const { atendimento } = useAtendimento()
  if (atendimento?.id) return <AtendimentoDropdownMenu cliente={atendimento.cliente} exibirItens={exibirItens} />

  return (
    <Button
      variant="secondary"
      className="font-nunito shadow-cz bg-white font-semibold text-neutral-700"
      onClick={() => navigate('/atendimento/iniciar')}
    >
      <>
        <Icon name="square-play" className="text-neutral-400" size={20} />
        {t('iniciar_atendimento')}
      </>
    </Button>
  )
}
